import {
    changeFormat,
    convertDate,
    datePlus1day,
    datePlus1DayFormat,
    getEndSecond,
    meterToKilo,
    secToHourMinute,
    secToHourMinuteExcel
} from "@/components/tacho/common/CommonFunc";
import axios from "@/composables/Axios";
import dayjs from "dayjs";
import xlsx from "xlsx-js-style";
import excelEntity from "@/entity/ExcelEntity";

const sortingExcelArray = async (column, order, arr) => {
    let result = [];

    if( arr.length == 0 ){
        return result;
    }

    let stringCheck = isNaN( arr[0][column] );

    if( stringCheck ) {
        if( order == "asc" ) {
            result = arr.sort( (a, b)=>{
                if( a[column] > b[column] ) return 1;
                if( a[column] < b[column] ) return -1;
                return 0;
            });
        }
        else if(order == "desc") {
            result = arr.sort( (a, b)=>{
                if( a[column] < b[column] ) return 1;
                if( a[column] > b[column] ) return -1;
                return 0;
            });
        }
    }
    else {
        if( order == "asc" ) {
            result = arr.sort( (a, b)=>{
                if( parseFloat(a[column]) > parseFloat(b[column]) ) return 1;
                if( parseFloat(a[column]) < parseFloat(b[column]) ) return -1;
                return 0;
            });
        }
        else if(order == "desc") {
            result = arr.sort( (a, b)=>{
                if( parseFloat(a[column]) < parseFloat(b[column]) ) return 1;
                if( parseFloat(a[column]) > parseFloat(b[column]) ) return -1;
                return 0;
            });
        }
    }

    return result;
}

const excel = async (url, params, companyName, fileName, titles, headers, entity) => {
    const xlsx = require('xlsx');
    const book = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    const size = 3000
    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, { params: params}, headers);
        res.data.data.content.map(v=>resultList.push(Object.assign({}, entity.fromMap(v))));
        isLast = res.data.data.last;
        page++;
    }
    const ws = xlsx.utils.json_to_sheet(resultList, {origin: 'A2', skipHeader: true});
    xlsx.utils.sheet_add_aoa(ws, [titles])
    xlsx.utils.book_append_sheet(book, ws);
    if(params.queryDate === undefined){
        xlsx.writeFile(book,`${companyName}_${fileName}_${params.startDate}_${params.endDate}.xlsx`);
    }else{
        xlsx.writeFile(book,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }

}

const fetchPeriods = async (url, params, headers, periods = []) => {
    const dataList = [];
    const size = 3000;
    if (periods.length === 0) {
        if (params.startDate) {
            periods.push({
                startDate: params.startDate,
                endDate: params.endDate
            });
        } else {
            periods.push({
                fromDtti: params.fromDtti,
                untilDtti: params.untilDtti
            });
        }
    }

    for (const period of periods) {
        let isLast = false;
        let page = 0;
        const reqParams = {...params, ...period};
        while (!isLast){
            const res = await axios.$get(
                `${url}?page=${page}&size=${size}`,
                {params: reqParams},
                headers,
            );
            dataList.push(...res.data.data.content);
            isLast = res.data.data.last;
            page++;
        }
    }

    return {
        dataList,
        periods
    };
}

const excelDriving = async (url, params, companyName, fileName, titles, headers, entity, sumEntity
                            , isShowHipassFare, isShowAddFare, isShowTotalFare, orderData, periods) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    const { dataList } = await fetchPeriods(url, params, headers, periods);
    dataList.map(v=>{
        v.allDist = v.workDist + v.blankDist;
        v.blankTime = v.allTime - v.workTime;
    });

    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());
    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    if (isShowHipassFare === false) {
        ws["!cols"][7] = { hidden: true };
    }

    if (isShowAddFare === false) {
        ws["!cols"][9] = { hidden: true };
    }

    if (isShowTotalFare === false) {
        ws["!cols"][10] = { hidden: true };
    }

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    let lastUntilDtti = null;

    if (periods && periods.length > 0) { //파일명 설정_ 마지막 기간의 종료일자
        const lastPeriod = periods[periods.length - 1];
        lastUntilDtti = lastPeriod.untilDtti || lastPeriod.endDate ;
    }

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        } else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${lastUntilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}
const excelVoucher = async (url, params, companyName, fileName, titles, headers, entity, sumEntity, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    let cnt = 1;
    const size = 3000
    const isCorporate = params.officeId !== undefined;
    // STEP 2: Create data rows and styles

    let dataList = [];
    const fields =  entity.fields();
    const privateFields =  ["no", "carNum", "stDtti", "edDtti","tripDist","distFare","voucherDiscount","hipassFee","callFee","addFare","jibulFee","payTotal","payType","payStartDtti"];
    const selectedFields = isCorporate ? fields : fields.filter(f => privateFields.includes(f.key));
    const selectedKeys   = selectedFields.map(f => f.key);

    resultList.push(titles);

    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        dataList.push(...res.data.data.content);
        isLast = res.data.data.last;
        page++;
    }

    dataList.forEach(item => {
        const fullRow = entity.fromMap(cnt++, item); // 전체 row
        const row = selectedKeys.map(k => {
            const index = fields.findIndex(f => f.key === k);
            return fullRow[index];
        });
        resultList.push(row);
        // resultList.push(entity.fromMap(cnt++, item));
    });

    let ws = xlsx.utils.aoa_to_sheet(resultList);

    ws['!cols'] = isCorporate
        ? new excelEntity.excelTachoVoucherDto().cols()
        : new excelEntity.excelPrivateTachoVoucherDto().cols();


    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.dttiGte || params.startDate;
    const untilDtti = params.dttiLt || params.endDate;

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        }
        else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}
const excelDrivingDist = async (url, params, companyName, fileName, titles, headers, entity, sumEntity, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    let cnt = 1;
    const size = 3000
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    let dataList = [];
    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        dataList.push(...res.data.data.content);
        isLast = res.data.data.last;
        page++;
    }

    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());
    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        }
        else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const excelDrivingPeriod = async (url, params, companyName, fileName, titles, headers, entity, sumEntity
    , isShowHipassFare, isShowAddFare, isShowTotalFare, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    let cnt = 1;
    const size = 3000
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    let dataList = [];
    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        dataList.push(...res.data.data.content);
        isLast = res.data.data.last;
        page++;
    }
    dataList.map(v=>{
        v.allDist = v.workDist + v.blankDist;
        v.blankTime = v.allTime - v.workTime;
    });

    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());
    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    if (isShowHipassFare === false) {
        ws["!cols"][5] = { hidden: true };
    }

    if (isShowAddFare === false) {
        ws["!cols"][7] = { hidden: true };
    }

    if (isShowTotalFare === false) {
        ws["!cols"][8] = { hidden: true };
    }

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        }
        else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const excelDrivingDetail = async (url, params, companyName, fileName, titles, headers, entity, sumEntity, isShowHipassFare, isShowAddFare, isShowTotalFare, orderData, periods) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    const { dataList } = await fetchPeriods(url, params, headers, periods);
    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        if( orderData.column == 'cashFare' ) {
            orderData.column = 'allCashPayFare';
        }
        else if( orderData.column == 'cardFare' ) {
            orderData.column = 'allCardPayFare';
        }
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());
    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    if (isShowHipassFare === false) {
        ws["!cols"][7] = { hidden: true };
    }

    if (isShowAddFare === false) {
        ws["!cols"][9] = { hidden: true };
    }

    if (isShowTotalFare === false) {
        ws["!cols"][10] = { hidden: true };
    }

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        } else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const excelDrivingWorld = async (url, params, companyName, fileName, titles, headers, entity, sumEntity, orderData, periods) => {
    const xlsx = require('xlsx-js-style');
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    const { dataList } = await fetchPeriods(url, params, headers, periods);
    dataList.map(v=>{
        v.allDist = v.workDist + v.blankDist;
        v.blankTime = v.allTime - v.workTime;
    });

    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());
    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        }
        else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const txtDrivingWorldDay = async (url, searchParams, companyName, fileName, titles, headers, orderData) => {
    let dataList = [];

    let curDtti = searchParams.fromDtti;
    let nextDtti;
    while (curDtti < searchParams.untilDtti) {
        nextDtti = dayjs(curDtti, 'YYYYMMDDHHmmss').add(1, 'day').format('YYYYMMDDHHmmss');
        if (nextDtti > searchParams.untilDtti) {
            nextDtti = searchParams.untilDtti;
        }

        const currSearchParams = {
            ...searchParams,
            fromDtti: curDtti,
            untilDtti: nextDtti,
        };

        let page = 0;
        const size = 3000;
        let isLast = false;

        while (!isLast) {
            const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: currSearchParams}, headers);
            dataList.push(...res.data.data.content);
            isLast = res.data.data.last;
            page++;
        }

        curDtti = nextDtti;
    }

    let rowList = [];
    dataList.forEach((data, index) => {
        let row = [];
        let stDate = changeFormat(data.minDtti, "YYYY-MM-DD HH:mm");
        let edDate = changeFormat(data.maxDtti, "YYYY-MM-DD HH:mm");
        let workDist = meterToKilo(data.workDist).toFixed(1);
        let blankDist = meterToKilo(data.blankDist).toFixed(1);
        let allDist = meterToKilo(data.workDist + data.blankDist).toFixed(1);
        let workTime = secToHourMinuteExcel(data.workTime);
        let blankTime = secToHourMinuteExcel(data.allTime - data.workTime);
        let allTime = secToHourMinuteExcel(data.allTime);
        row.push(++index, data.carNum, data.driverId, stDate + "~" + edDate
            , (data.fare - data.addFare - data.hipassFare), data.cashFare, data.cardFare
            , workDist, blankDist, allDist
            , workTime, blankTime, allTime);
        rowList.push(row.join(","));
    });

    let csvList = rowList.join("\n");

    let csvFile;
    let downloadLink;

    const BOM = "\uFEFF";
    csvList = BOM + csvList;

    csvFile = new Blob([csvList], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = companyName + "_" + fileName + "_" + searchParams.fromDtti + "_" + searchParams.untilDtti + ".txt";
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
}

const txtDrivingWorldPeriod = async (url, params, companyName, fileName, titles, headers, orderData) => {
    let dataList = [];

    let page = 0;
    const size = 3000;
    let isLast = false;
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        dataList.push(...res.data.data.content);
        isLast = res.data.data.last;
        page++;
    }

    let rowList = [];
    dataList.forEach((data, index) => {
        let row = [];
        let stDate = changeFormat(data.stDtti, "YYYY-MM-DD HH:mm");
        let edDate = changeFormat(data.edDtti, "YYYY-MM-DD HH:mm");
        let workDist = meterToKilo(data.workDist).toFixed(1);
        let blankDist = meterToKilo(data.blankDist).toFixed(1);
        let allDist = meterToKilo(data.workDist + data.blankDist).toFixed(1);
        let workTime = secToHourMinuteExcel(data.workTime);
        let blankTime = secToHourMinuteExcel(data.allTime - data.workTime);
        let allTime = secToHourMinuteExcel(data.allTime);
        row.push(++index, data.carNum, data.driverId, stDate + "~" + edDate
            , (data.fare - data.addFare - data.hipassFare)
            , (data.cashFare)
            , (data.cardFare)
            , workDist, blankDist, allDist
            , workTime, blankTime, allTime);
        rowList.push(row.join(","));
    });

    let csvList = rowList.join("\n");

    let csvFile;
    let downloadLink;
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    const BOM = "\uFEFF";
    csvList = BOM + csvList;

    csvFile = new Blob([csvList], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = companyName + "_" + fileName + "_" + fromDtti + "_" + untilDtti + ".txt";
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
}

function splitRangeIntoDays(startDateStr, endDateStr) {
    const startDate = dayjs(startDateStr, 'YYYYMMDDHHmmss');
    const endDate = dayjs(endDateStr, 'YYYYMMDDHHmmss');

    const ranges = [];
    let currentDate = startDate;
    while (currentDate.isBefore(endDate)) {
        let nextDate = currentDate.add(1, 'day');
        if (nextDate.isAfter(endDate)) {
            nextDate = endDate;
        }

        ranges.push({
            startDate: currentDate.format('YYYYMMDDHHmmss'),
            endDate: nextDate.subtract(1, 'seconds').format('YYYYMMDDHHmmss')
        });
        currentDate = nextDate;
    }

    return ranges;
}

const excelDrivingAggregateDetail = async (url, params, companyName, fileName, titles, headers, entity, isShowHipassFare, isShowAddFare, isShowTotalFare, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    const size = 3000
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    let dataList = [];
    let ranges = [
        {
            startDate: params.startDate,
            endDate: params.endDate
        }
    ];
    if (
        typeof params.startDate !== 'undefined'
        && typeof params.endDate !== 'undefined'
    ) {
        ranges = splitRangeIntoDays(params.startDate, params.endDate);
    }

    for (const range of ranges) {
        const tempParams = {...params};
        let page = 0;
        let isLast = false;
        while (!isLast) {
            if (range.startDate) {
                tempParams.startDate = range.startDate;
            }
            if (range.endDate) {
                tempParams.endDate = range.endDate;
            }
            const res = await axios.$get(`${url}?page=${page}&size=${size}&excludeNotFound=Y`, {params: tempParams}, headers);
            dataList.push( ...res.data.data.content );
            isLast = res.data.data.last;
            page++;
        }
    }

    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
        });
    } else {
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
            });
        });
    }

    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    if (isShowHipassFare === false) {
        ws["!cols"][7] = { hidden: true };
    }

    if (isShowAddFare === false) {
        ws["!cols"][9] = { hidden: true };
    }

    if (isShowTotalFare === false) {
        ws["!cols"][10] = { hidden: true };
    }

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    if(params.queryDate === undefined){
        xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const excelForManage = async (url, params, fileName, titles, headers) => {
    const xlsx = require('xlsx');
    const book = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    const size = 3000
    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, { params: params}, headers);
        res.data.data.content.map(v=>resultList.push(v));
        isLast = res.data.data.last;
        page++;
    }
    const ws = xlsx.utils.json_to_sheet(resultList, {origin: 'A2', skipHeader: true});
    xlsx.utils.sheet_add_aoa(ws, [titles])
    xlsx.utils.book_append_sheet(book, ws);
    xlsx.writeFile(book,`${fileName}.xlsx`);
}

const excelToJson = async (file) => {
    const xlsx = require('xlsx');
    return new Promise((resolve, reject)=> {
        let reader = new FileReader();
        let tmpResult = {};
        reader.onload = (e) => {
            let data = reader.result;
            let wb = xlsx.read(data, {type: 'binary', cellDates: true, dateNF: 'yyyy-mm-dd'})
            wb.SheetNames.forEach(sheetName => {
                tmpResult = xlsx.utils.sheet_to_json(wb.Sheets[sheetName])
            });

            tmpResult.forEach(rowData => {
                for (let key in rowData) {
                    if (key === "regDt") {
                        const parsedValue = convertDate(rowData['regDt']);
                        rowData[key] = parsedValue;
                    } else {
                        const parsedValue = rowData[key].toString();
                        rowData[key] = parsedValue;
                    }
                }
            })
            resolve(tmpResult);
        }
        reader.readAsBinaryString(file);
    });
}

const txtClosingCommuteWorldDay = async (url, params, companyName, fileName, titles, headers, orderData) => {
    let dataList = [];

    let page = 0;
    const size = 3000;
    let isLast = false;
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}&excludeNotFound=Y`, {params: params}, headers);
        dataList.push(...res.data.data.content);
        isLast = res.data.data.last;
        page++;
    }

    let rowList = [];
    dataList.forEach((data, index) => {
        let row = [];

        let stDate;
        if (data.stDtti == null) {
            stDate = changeFormat(params.workDate + "000000", 'YYYY-MM-DD HH:mm');
        } else {
            stDate = changeFormat(data.stDtti, 'YYYY-MM-DD HH:mm');
        }

        let edDate;
        if (data.edDtti == null) {
            edDate = changeFormat(datePlus1day(data.stDtti), 'YYYY-MM-DD 00:00');
        } else {
            edDate = changeFormat(data.edDtti, 'YYYY-MM-DD HH:mm');
        }

        let workDist = meterToKilo(data.workDist).toFixed(1);
        let blankDist = meterToKilo(data.blankDist).toFixed(1);
        let allDist = meterToKilo(data.allDist).toFixed(1);
        let workTime = secToHourMinuteExcel(data.workTime);
        let blankTime = secToHourMinuteExcel(data.blankTime);
        let allTime = secToHourMinuteExcel(data.allTime);
        row.push(++index, data.carNum, data.driverId, stDate + "~" + edDate
            , parseInt(data.allFare) - parseInt(data.addFare) - parseInt(data.hipassFare), data.cashFare, data.cardFare
            , workDist, blankDist, allDist
            , workTime, blankTime, allTime);
        rowList.push(row.join(","));
    });

    let csvList = rowList.join("\n");

    let csvFile;
    let downloadLink;

    const BOM = "\uFEFF";
    csvList = BOM + csvList;

    const dateFormatted = params.fromDtti
        ? changeFormat(params.fromDtti, 'YYYYMMDD')
        : params.workDate;

    csvFile = new Blob([csvList], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = companyName + "_" + fileName + "_" + dateFormatted + ".txt";
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
}

const txtClosingCommuteWorldPeriod = async (url, params, companyName, fileName, titles, headers, orderData) => {
    let dataList = [];

    let page = 0;
    const size = 3000;
    let isLast = false;
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}&excludeNotFound=Y`, {params: params}, headers);
        dataList.push(...res.data.data.content);
        isLast = res.data.data.last;
        page++;
    }

    let rowList = [];
    dataList.forEach((data, index) => {
        let row = [];

        let stDate;
        if (data.stDtti == null) {
            let tempDate = changeFormat(data.edDtti, 'YYYYMMDD');
            stDate = changeFormat(tempDate + "000000", 'YYYY-MM-DD HH:mm');
        } else {
            stDate = changeFormat(data.stDtti, 'YYYY-MM-DD HH:mm');
        }
        let edDate;
        if (data.edDtti == null) {
            edDate = changeFormat(datePlus1day(data.stDtti), 'YYYY-MM-DD 00:00');
        } else {
            edDate = changeFormat(data.edDtti, 'YYYY-MM-DD HH:mm');
        }

        let workDist = meterToKilo(data.workDist).toFixed(1);
        let blankDist = meterToKilo(data.blankDist).toFixed(1);
        let allDist =meterToKilo(data.allDist).toFixed(1);
        let workTime = secToHourMinuteExcel(data.workTime);
        let blankTime = secToHourMinuteExcel(data.blankTime);
        let allTime = secToHourMinuteExcel(data.allTime);
        row.push(++index, data.carNum, data.driverId, stDate + "~" + edDate
            , (parseInt(data.allFare) - parseInt(data.addFare) - parseInt(data.hipassFare))
            , (parseInt(data.cashFare))
            , (parseInt(data.cardFare))
            , workDist, blankDist, allDist
            , workTime, blankTime, allTime);
        rowList.push(row.join(","));
    });

    let csvList = rowList.join("\n");

    let csvFile;
    let downloadLink;

    const BOM = "\uFEFF";
    csvList = BOM + csvList;

    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    csvFile = new Blob([csvList], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = companyName + "_" + fileName + "_" + fromDtti + "_" + untilDtti + ".txt";
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";
    document.body.appendChild(downloadLink);
    downloadLink.click();
}

const excelClosingCommuteDay = async (division, url, params, companyName, fileName, titles, headers, entity, sumEntity, isShowHipassFare, isShowAddFare, isShowTotalFare, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    let cnt = 1;
    const size = 3000
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;
    let tempDate = changeFormat(fromDtti, 'YYYYMMDD');

    let dataList = [];
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}&excludeNotFound=Y`, {params: params}, headers);
        dataList.push(...res.data.data.content);

        isLast = res.data.data.last;
        page++;
    }

    dataList.forEach(element => {
        let tempStartDate = changeFormat(tempDate + "000000", 'YYYY-MM-DD HH:mm:ss')
        let tempEndDate = changeFormat(datePlus1day(element.stDtti), 'YYYY-MM-DD 00:00:00');
        element.stDtti = element.stDtti != null ? element.stDtti : tempStartDate;
        element.edDtti = element.edDtti != null ? element.edDtti : tempEndDate;
    });

    if( orderData === undefined ) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        orderData.column = orderData.column == "addFare" ? "allAddFare" : orderData.column;
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());

    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    switch(division) {
        case "excelDriving": {
            if (isShowHipassFare === false) {
                ws["!cols"][7] = { hidden: true };
            }
            if (isShowAddFare === false) {
                ws["!cols"][9] = { hidden: true };
            }
            if (isShowTotalFare === false) {
                ws["!cols"][10] = { hidden: true };
            }
            break;
        }

        case "excelDrivingDetail": {
            if (isShowHipassFare === false) {
                ws["!cols"][7] = { hidden: true };
            }
            if (isShowAddFare === false) {
                ws["!cols"][9] = { hidden: true };
            }
            if (isShowTotalFare === false) {
                ws["!cols"][10] = { hidden: true };
            }
            break;
        }

        case "excelDrivingWorld": {
            break;
        }
    }
    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        }
        else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const excelClosingCommutePeriod = async (division, url, params, companyName, fileName, titles, headers, entity, sumEntity, isShowHipassFare, isShowAddFare, isShowTotalFare, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let isLast = false
    let resultList = [];
    let page = 0
    let cnt = 1;
    const size = 3000
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    let tempDate = '';

    let dataList = [];
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}&excludeNotFound=Y`, {params: params}, headers);
        dataList.push(...res.data.data.content);

        isLast = res.data.data.last;
        page++;
    }

    dataList.forEach(element => {
        if( element.stDtti == null ) {
            tempDate = changeFormat(element.edDtti, 'YYYYMMDD');
            element.stDtti = changeFormat(tempDate + "000000", 'YYYY-MM-DD HH:mm:ss');
        }
        if( element.edDtti == null ) {
            element.edDtti = changeFormat(datePlus1day(element.stDtti), 'YYYY-MM-DD 00:00:00');
        }

        switch(division) {
            case "excelDriving":
            case "excelDrivingDetail":
                element.allAddFare = parseInt(element.addFare) + parseInt(element.callFare);
                break;
        }
    });

    if( orderData === undefined ) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        orderData.column = orderData.column == "addFare" ? "allAddFare" : orderData.column;
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());

    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    switch(division) {
        case "excelDriving": {
            if (isShowHipassFare === false) {
                ws["!cols"][5] = { hidden: true };
            }
            if (isShowAddFare === false) {
                ws["!cols"][7] = { hidden: true };
            }
            if (isShowTotalFare === false) {
                ws["!cols"][8] = { hidden: true };
            }
            break;
        }

        case "excelDrivingDetail": {
            if (isShowHipassFare === false) {
                ws["!cols"][7] = { hidden: true };
            }
            if (isShowAddFare === false) {
                ws["!cols"][9] = { hidden: true };
            }
            if (isShowTotalFare === false) {
                ws["!cols"][10] = { hidden: true };
            }
            break;
        }

        case "excelDrivingWorld": {
            break;
        }
    }
    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    const fromDtti = params.fromDtti || params.startDate;
    const untilDtti = params.untilDtti || params.endDate;

    if(params.queryDate === undefined){
        if(fromDtti === undefined && untilDtti === undefined) {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${params.workDate}.xlsx`);
        }
        else {
            xlsx.writeFile(wb,`${companyName}_${fileName}_${fromDtti}_${untilDtti}.xlsx`);
        }
    }else{
        xlsx.writeFile(wb,`${companyName}_${fileName}_${params.queryDate.slice(0,7)}.xlsx`);
    }
}

const excelCommuteManage = async (url, params, companyName, fileName, titles, headers, entity, sumEntity, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    const res = await axios.$get(`${url}`, {params: params}, headers);
    let dataList = res.data.data;

    if(orderData === undefined) {
        dataList.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
            sumEntity.add(v);
        });
    }
    else {
        await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
            response.map(v=>{
                resultList.push(entity.fromMap(cnt++, v));
                sumEntity.add(v);
            });
        });
    }

    resultList.push(sumEntity.res());

    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    xlsx.writeFile(wb,`${companyName}_${fileName}_${params.stDtti}_${params.edDtti}.xlsx`);
}

const excelDrivingPerMinute = async (url, params, companyName, fileName, titles, headers, entity, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    let isLast = false;
    let page = 0;
    let size = 3000;

    let dataList = [];
    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        dataList.push(...res.data.data.content);

        isLast = res.data.data.last;
        page++;
    }

    await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
        response.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
        });
    });

    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    xlsx.writeFile(wb,`${companyName}_${fileName}_${params.startDate}_${params.endDate}.xlsx`);
}

const excelButtonEvent = async (url, params, companyName, fileName, titles, headers, entity, orderData) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    let resultList = [];
    let cnt = 1;
    // STEP 2: Create data rows and styles
    resultList.push(titles);

    let isLast = false;
    let page = 0;
    let size = 3000;

    let dataList = [];
    while (!isLast){
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        dataList.push(...res.data.data.content);

        isLast = res.data.data.last;
        page++;
    }

    await sortingExcelArray(orderData.column, orderData.order, dataList).then(response => {
        response.map(v=>{
            resultList.push(entity.fromMap(cnt++, v));
        });
    });

    let ws = xlsx.utils.aoa_to_sheet(resultList);
    ws["!cols"] = entity.cols();

    xlsx.utils.book_append_sheet(wb, ws, fileName);

    // STEP 4: Write Excel file to browser
    xlsx.writeFile(wb,`${companyName}_${fileName}_${params.startDate}_${params.endDate}.xlsx`);
}


const excelDrivingLastTransaction = (entityList, entity) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    const excelDatalist = [];
    excelDatalist.push(entity.getExcelHeaders());

    let mostRecentCreatedAt = null;
    entityList.forEach(v=>{
        if(mostRecentCreatedAt === null || mostRecentCreatedAt < v.createdAt) {
            mostRecentCreatedAt = v.createdAt;
        }
        excelDatalist.push(v.toExcelRow());
    });

    let ws = xlsx.utils.aoa_to_sheet(excelDatalist);
    ws["!cols"] = entity.getExcelColsDef();

    let fileNameSuffix = '';
    if(mostRecentCreatedAt !== null) {
        fileNameSuffix = `_${mostRecentCreatedAt.slice(0,10)}`;
    }

    xlsx.utils.book_append_sheet(wb, ws, `마지막거래내역`);
    xlsx.writeFile(wb,`마지막거래내역${fileNameSuffix}.xlsx`);
}

const excelLocationHistory = (entityList, entity) => {
    const xlsx = require('xlsx-js-style')
    const wb = xlsx.utils.book_new();
    const excelDatalist = [];
    excelDatalist.push(entity.getExcelHeaders());

    entityList.forEach(v => {
        excelDatalist.push(v.toExcelRow());
    });

    let ws = xlsx.utils.aoa_to_sheet(excelDatalist);
    ws["!cols"] = entity.getExcelColsDef();

    xlsx.utils.book_append_sheet(wb, ws, `위치정보조회이력`);

    const nowDate = dayjs().format('YYYYMMDD');
    xlsx.writeFile(wb,`위치정보조회이력_${nowDate}.xlsx`);
}

const excelDriverInfo = async (url, params, headers, DriverInfoEntity) => {
    const excelDataList = [
        DriverInfoEntity.excelTitles(),
    ];

    const size = 3000;
    let page = 0;
    let isLast = false;
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        res.data.data.content.forEach(v => {
            const item = DriverInfoEntity.fromApi(v);
            excelDataList.push(item.toExcelRow());
        })
        isLast = res.data.data.last;
        page++;
    }

    const ws = xlsx.utils.aoa_to_sheet(excelDataList);
    ws["!cols"] = DriverInfoEntity.excelCols();

    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, '기사관리');

    const nowDate = dayjs().format('YYYYMMDD');
    xlsx.writeFile(wb,`기사관리_${nowDate}.xlsx`);
}

const excelTaxiCarActivity = async(
    title,
    excelDataList,
    excelColWidths,
) => {
    const ws = xlsx.utils.aoa_to_sheet(excelDataList);
    ws["!cols"] = excelColWidths;

    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, '택시차량활동내역');

    xlsx.writeFile(wb,`${title}.xlsx`);
};

const excelVehicleInfo = async (url, params, headers, VehicleInfoEntity) => {
    const excelDataList = [
        VehicleInfoEntity.excelTitles(),
    ];

    const size = 3000;
    let page = 0;
    let isLast = false;
    while (!isLast) {
        const res = await axios.$get(`${url}?page=${page}&size=${size}`, {params: params}, headers);
        res.data.data.content.forEach(v => {
            const dv = VehicleInfoEntity.fromApi(v);
            excelDataList.push(dv.toExcelRow());
        })
        isLast = res.data.data.last;
        page++;
    }

    const ws = xlsx.utils.aoa_to_sheet(excelDataList);
    ws["!cols"] = VehicleInfoEntity.excelCols();

    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, '차량관리');

    const nowDate = dayjs().format('YYYYMMDD');
    xlsx.writeFile(wb,`차량관리_${nowDate}.xlsx`);
}

const commonService = {
    excel: excel,
    excelDriving: excelDriving,
    excelDrivingDist: excelDrivingDist,
    excelDrivingPeriod: excelDrivingPeriod,
    excelDrivingDetail: excelDrivingDetail,
    excelDrivingWorld: excelDrivingWorld,
    txtDrivingWorldDay: txtDrivingWorldDay,
    txtDrivingWorldPeriod: txtDrivingWorldPeriod,
    excelDrivingAggregateDetail: excelDrivingAggregateDetail,
    excelForManage: excelForManage,
    excelToJson: excelToJson,
    excelClosingCommuteDay: excelClosingCommuteDay,
    excelClosingCommutePeriod: excelClosingCommutePeriod,
    txtClosingCommuteWorldDay: txtClosingCommuteWorldDay,
    txtClosingCommuteWorldPeriod: txtClosingCommuteWorldPeriod,
    excelCommuteManage: excelCommuteManage,
    sortingExcelArray: sortingExcelArray,
    excelDrivingPerMinute: excelDrivingPerMinute,
    excelButtonEvent: excelButtonEvent,
    excelDrivingLastTransaction: excelDrivingLastTransaction,
    excelLocationHistory: excelLocationHistory,
    excelDriverInfo,
    excelVehicleInfo,
    excelVoucher : excelVoucher,
    excelTaxiCarActivity
}

export default commonService
